/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function RemoveIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "remove", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M6 12.5H19", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(RemoveIcon);
export default ForwardRef;
//# sourceMappingURL=removeIcon.js.map